import { Component, Input } from '@angular/core';
import { TicketHistory } from 'src/app/core/models/itinerary.model';

@Component({
  selector: 'app-ticket-histories',
  templateUrl: './ticket-histories.component.html',
  styleUrls: ['./ticket-histories.component.scss']
})
export class TicketHistoriesComponent {
  @Input() passengers: TicketHistory[];
  @Input() enabledCheckboxes = false;

  expand(event, i) {
    event.preventDefault();
    this.passengers[i].isOpen = !this.passengers[i].isOpen;
  }
}
